var staticDecodeURIComponent = decodeURIComponent

module.exports = staticDecodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticDecodeURIComponent.js
// module id = 617
// module chunks = 106